import React from 'react'
import SliderGallery from '../components/SliderGallery'



const GraniteGallery = () => {

  const galleryImages = [

    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-24.jpg",
      alt:'Dec-Tec membrane in various applications and settings 1'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-18.jpg",
      alt:'Dec-Tec membrane in various applications and settings 2'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-17.jpg",
      alt:'Dec-Tec membrane in various applications and settings 3'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-16.jpg",
      alt:'Dec-Tec membrane in various applications and settings 4'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-15.jpg",
      alt:'Dec-Tec membrane in various applications and settings 5'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-14.jpg",
      alt:'Dec-Tec membrane in various applications and settings 6'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-13.jpg",
      alt:'Dec-Tec membrane in various applications and settings 7'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-12.jpg",
      alt:'Dec-Tec membrane in various applications and settings 8'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-11-rotated.jpg",
      alt:'Dec-Tec membrane in various applications and settings 9'
    },

    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-10-rotated.jpg",
      alt:'Dec-Tec membrane in various applications and settings 23'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-9.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 24'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-19.jpg",
      alt:'Dec-Tec membrane in various applications and settings 25'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-8-rotated.jpg",
      alt:'Dec-Tec membrane in various applications and settings 26'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-7.jpg",
      alt:'Dec-Tec membrane in various applications and settings 27'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-6.jpg",
      alt:'Dec-Tec membrane in various applications and settings 28'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-5.jpg",
      alt:'Dec-Tec membrane in various applications and settings 29'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-4.jpg",
      alt:'Dec-Tec membrane in various applications and settings 30'
    },

  {
    img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-3.jpg",
    alt:'Dec-Tec membrane in various applications and settings 31'
  },
  {
    img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-2.jpg",
    alt:'Dec-Tec membrane in various applications and settings 32'
  },
  {
    img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-1-rotated.jpg",
    alt:'Dec-Tec membrane in various applications and settings 33'
  },
  
  {
    img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-25.jpg",
    alt:'Dec-Tec membrane in various applications and settings 34'
  },
  {
    img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-23.jpg",
    alt:'Dec-Tec membrane in various applications and settings 35'
  },
  {
    img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-22.jpg",
    alt:'Dec-Tec membrane in various applications and settings 36'
  },
    
  {
    img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-21.jpg",
    alt:'Dec-Tec membrane in various applications and settings 37'
  },
  {
    img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Granite-20.jpg",
    alt:'Dec-Tec membrane in various applications and settings 38'
  },
  {
    img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/DT-CL-Granite-1.jpg",
    alt:'Dec-Tec membrane in various applications and settings 39'
  },
  // {
  //   img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/AdobeStock_102098745_GRANITE-min.jpg",
  //   alt:'Dec-Tec membrane in various applications and settings 40'
  // },
  // {
  //   img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/AdobeStock_35503998_GRANITE-min.jpg",
  //   alt:'Dec-Tec membrane in various applications and settings 41'
  // },



  ]


  return (
    <div>
      <SliderGallery
        title="Granite"
        para1="One of our most popular membranes, Granite is a stunning design. Save time and maintenance of your current deck with granite’s cool colors, perfect for creating a contrast in warm color tones and complementing greys and blues."
        galleryImages={galleryImages}
        previouslink="/brick-gallery/"
      />
    </div>
  )
}

export default GraniteGallery
